<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <span class="ls-title"></span>
      <ul class="ls-items">
        <li v-for="(w, i) in widths" :key="i" class="ls-item">
          <span class="ls-dot"></span>
          <span class="ls-line" :style="{ width: w + '%' }"></span>
        </li>
      </ul>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewList',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
  data() {
    return { widths: [70, 55, 64, 48] }
  },
})
</script>

<style scoped lang="scss">
.ls-title {
  display: block;
  height: 12px;
  width: 50%;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.22);
  margin-bottom: 4px;
}
.ls-items {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 9px;
}
.ls-item {
  display: grid;
  grid-template-columns: 12px 1fr;
  align-items: center;
  gap: 10px;
}
.ls-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--accent);
  margin-left: 2px;
}
.ls-line {
  height: 8px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.1);
}
</style>
